(function ($) {
	"use strict";
	$(function () {
		var isButtonClick = false;


		$('.js-newsletter-form').submit(function (e) {
			e.preventDefault();
			var $this = $(this);


			if (isButtonClick) {
				return false;
			}

			isButtonClick = true;

			$.ajax({
				type: "post",
				context: this,
				dataType: "json",
				url: localize.ajaxurl,
				data: {
					action: "mailchimpsubscribe",
					datas: $this.serializeArray(),
				},
				success: function (response) {
					isButtonClick = false;

					const popup = $this.hasClass('js-popup-newsletter');

					if (!response['fault']) {
						if ($('.js-newsletter-form').hasClass('modal-newsletter-form') && popup) {
							$('.newsletter-popup__success-screen').addClass('is-active');
							$('.newsletter-popup__subscribe-screen').removeClass('is-active')
							$('.newsletter-popup').removeClass('is-wider')
							return;
						}

						$this.trigger('reset');
						$('#dialog-content').removeClass('error');
						$('#dialog-content p').html(response['msg']);
						Fancybox.show([{ src: "#dialog-content", type: "inline" }]);

					} else {
						if (response['mailchimp_error']) {
							alert(response['msg']);
						} else {
							$('#dialog-content').addClass('error');
							$('#dialog-content p').html(response['msg']);
							Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
						}
					}
				}
			});

			return false;

		});

	});
})(jQuery);
